import { MenuItem, Select, Typography, SvgIcon } from "@mui/material";
import { ICancelBroadbandForm } from "@features/CancelBroadband/interface/ICancelBroadbandForm";
import { Controller, UseFormMethods } from "react-hook-form";
import { useStyle } from "./style";
import warningIconImg from "@static/img/icons/warning.svg";

interface IParams {
    cancelBroadbandForm: UseFormMethods<ICancelBroadbandForm> & Partial<UseFormMethods>;
    dropdownValueList: string[];
    placeholder: string;
    formField: keyof ICancelBroadbandForm;
    errorMessage?: string;
    label?: string;
    required?: boolean;
}

export const ControlledSelect = (props: IParams) => {
    const {
        cancelBroadbandForm,
        dropdownValueList,
        placeholder,
        formField,
        label,
        errorMessage,
        required = false,
    } = props;
    const { control, errors } = cancelBroadbandForm;
    const { classes } = useStyle(Boolean(errors[formField]));

    return (
        <div className={classes.container}>
            {label && (
                <Typography align="left" color="white" id={formField} variant="normal">
                    {label}
                </Typography>
            )}
            <Controller
                control={control}
                name={formField}
                render={({ name, value, onChange }) => (
                    <div className={classes.border}>
                        <Select
                            disableUnderline
                            displayEmpty
                            error={Boolean(errors[formField])}
                            fullWidth
                            id={formField}
                            name={name}
                            renderValue={(selected) => {
                                return (
                                    <Typography color="secondary" variant="normal">
                                        {selected || placeholder}
                                    </Typography>
                                );
                            }}
                            value={value}
                            variant="filled"
                            onChange={onChange}
                        >
                            {dropdownValueList.map((dropdownValue) => (
                                <MenuItem className={classes.reason} key={dropdownValue} value={dropdownValue}>
                                    <Typography color="secondary" variant="normal">
                                        {dropdownValue}
                                    </Typography>
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                )}
                rules={{
                    required,
                }}
            />
            {errorMessage && (
                <div className={classes.errorMessage}>
                    <SvgIcon component={warningIconImg} data-testid="svg-icon" />
                    <Typography color="primary.contrastText" variant="small">
                        {errorMessage}
                    </Typography>
                </div>
            )}
        </div>
    );
};
